import React, { useState, useEffect } from 'react';
import { TaskLoader } from '@doxyme/ui';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import './purchase-success.scss';
export const PurchaseSuccess = () => {
    const { formatMessage } = useIntl();
    const history = useHistory();
    const [loaderStatus, setLoaderStatus] = useState(null);
    useEffect(() => {
        setTimeout(() => {
            setLoaderStatus('success');
        }, 2000);
        setTimeout(() => {
            history.push('/account/dashboard');
        }, 4000);
    }, []);
    return (<div data-test-id="purchase-success-container">
      <div className="purchase-success__task-loader-container">
        <TaskLoader loadingLabel={formatMessage({
            id: 'auth.purchase-success.loader-pending',
            defaultMessage: 'preparing your doxy.me account...',
        })} statusLabel={loaderStatus === 'success'
            ? formatMessage({
                id: 'auth.purchase-success.loaderSuccess',
                defaultMessage: 'Your doxy.me account is ready!',
            })
            : ''} status={loaderStatus}/>
      </div>
    </div>);
};
